import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import Home from "@/pages/Home";
import Sell from "@/pages/Sell";
import Confirmation from "@/pages/Confirmation";
import AdminSignIn from "@/pages/AdminSignIn";
import AdminSignUp from "@/pages/AdminSignUp";
import AdminDashboard from "@/pages/AdminDashboard";
import SiteNav from "@/components/SiteNav";

function App() {
  return (
    <BrowserRouter>
      <ClerkAuthProvider>
        <SiteNav />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/sell" element={<Sell />} />
          <Route path="/confirmation/:orderId" element={<Confirmation />} />
          <Route path="/admin/sign-in/*" element={<AdminSignIn />} />
          <Route path="/admin/sign-up/*" element={<AdminSignUp />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
        <Toaster position="top-center" richColors />
      </ClerkAuthProvider>
    </BrowserRouter>
  );
}

export default App;
